module.exports = {
	"defaultEnv": "cw",
	"envs": {
		"cw": {
			"appPath": "/cw/",
			"graphqlUri": "/api/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"tokenRefreshUri": "/api/auth/v1/token/",
			"uploadUri": "/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"preprod": {
			"appPath": "/cw/",
			"resourcePath": "https://resource.mycrowdwisdom.com/ui/preprod/v1/",
			"graphqlUri": "https://rest.mycrowdwisdom.net/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"tokenRefreshUri": "https://auth.mycrowdwisdom.net/v1/token/",
			"uploadUri": "https://uploader.mycrowdwisdom.net/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"prod": {
			"appPath": "/cw/",
			"resourcePath": "https://resource.mycrowdwisdom.com/ui/prod/v1/",
			"graphqlUri": "https://rest.mycrowdwisdom.com/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"uploadUri": "https://uploader.mycrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"uat": {
			"appPath": "/cw/",
			"resourcePath": "https://resource.mycrowdwisdom.com/ui/uat/v2/",
			"graphqlUri": "https://rest.uatcrowdwisdom.com/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"tokenRefreshUri": "https://auth.uatcrowdwisdom.com/v1/token/",
			"uploadUri": "https://upload.uatcrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"prod2": {
			"appPath": "/cw/",
			"resourcePath": "https://resource.mycrowdwisdom.com/ui/prod/v2/",
			"graphqlUri": "/api/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"tokenRefreshUri": "https://env2.mycrowdwisdom.com/api/auth/v1/token/",
			"uploadUri": "https://uploader.mycrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		},
		"prc": {
			"appPath": "/cwcn/",
			"resourcePath": "/rcdn/ui/prod/prc/",
			"graphqlUri": "/api/graphql/v1",
			"gatewayUri": "/diweb/gateway/init/1",
			"logoutUri": "/diweb/signoff",
			"tokenRefreshUri": "/auth/v1/token/",
			"uploadUri": "https://uploader.mycrowdwisdom.com/upload/file",
			"keepaliveUri": "/diweb/keepalive"
		}
	},
	"sentryUri": "https://f4db9ed9fd4341e8b9d6b73cfb10f7fc@o387825.ingest.sentry.io/5223707",
	"editingEnabled": false,
	"service.resolver": "apollo",
	"startup": [
		"CONFIG_LOAD_SUCCESS",
		"LAYOUT_LOAD_SUCCESS",
		"USER_ALL_CONDITIONS_SET"
	]
};


//////////////////
// WEBPACK FOOTER
// ./app.config.prod.json
// module id = 1456
// module chunks = 0